import { getPieceMoveSet, applyMoveToMapData } from './movementHelpers';
import { BLUE_PIECES, RED_PIECES, COLORLESS_PIECES } from './constants';
import { getMapPieceData } from './gameplay';
import { tileInRect } from './mapHelpers';
import { getPossibleBowTargets } from './abilities';

export function getRectFromRoom(room) {
  let rect = room[0];
  room.forEach((roomSection, index) => {
    if (index > 0) {
      const x = Math.min(rect.x, roomSection.x);
      const y = Math.min(rect.y, roomSection.y);
      const w = Math.max(rect.x + rect.w, roomSection.x + roomSection.w) - x;
      const h = Math.max(rect.y + rect.h, roomSection.y + roomSection.h) - y;
      rect = { x, y, w, h };
    }
  });
  rect.centerX = rect.x + rect.w / 2;
  rect.centerY = rect.y + rect.h / 2;
  return rect;
}

export function getNextMoveScores(details, moveMap, color) {
  const { hasKey, isCastle, activeRooms, battleZone } = details;

  let activePieces = [];
  moveMap.forEach((tileValue, index) => {
    const group =
      color === 'red' ? RED_PIECES.concat(COLORLESS_PIECES) : BLUE_PIECES;
    if (group.includes(tileValue)) {
      const x = index % battleZone.w;
      const y = Math.floor(index / battleZone.w);
      const tile = { x, y };
      if (activeRooms) {
        activeRooms.rooms.forEach(room => {
          let roomRect = getRectFromRoom(room);
          let rect = {
            x: 0,
            y: 0,
            w: roomRect.w,
            h: roomRect.h
          };
          if (isCastle) {
            rect.x = roomRect.x;
            rect.y = roomRect.y;
          }
          if (tileInRect(tile, rect)) {
            activePieces.push({ x, y, index: tileValue });
          }
        });
      } else {
        activePieces.push({ x, y, index: tileValue });
      }
    }
  });
  let possibleMoves = [];
  activePieces.forEach(piece => {
    let moveSet = getPieceMoveSet(
      piece.tile || piece,
      moveMap,
      battleZone.w,
      hasKey
    );
    moveSet.attackSet
      .concat(moveSet.moveSet)
      .map(move => ({ piece, move }))
      .forEach(move => {
        possibleMoves.push(move);
      });
  });
  //   console.log('checking moves:', activePieces.length, possibleMoves.length);
  let nextMaps = [];
  possibleMoves.forEach(move => {
    const moveMapData = applyMoveToMapData(
      moveMap,
      move.piece,
      move.move,
      battleZone
    );
    nextMaps.push(moveMapData);
  });
  return { possibleMoves, nextMaps };
}

export function hasValidMoves(map, color, ignoreActiveRooms = true) {
  const { possibleMoves, possibleItemMoves } = getPossibleMovesNextMaps(
    map,
    color,
    ignoreActiveRooms
  );

  return possibleMoves.length > 0 || possibleItemMoves.length > 0
    ? true
    : false;
}

export function determineMove(map, color, ignoreActiveRooms = true) {
  const {
    possibleMoves,
    nextMaps,
    hasKey,
    isCastle,
    activeRooms,
    battleZone,
    rootMap
  } = getPossibleMovesNextMaps(map, color, ignoreActiveRooms);

  window.aiWorker.postMessage({
    type: window.ai.method,
    maps: nextMaps,
    possibleMoves: possibleMoves,
    rootMap,
    color,
    turnLimit: window.ai['future looking limit'],
    details: { hasKey, isCastle, activeRooms, battleZone }
  });
}

function getPossibleMovesNextMaps(map, color, ignoreActiveRooms = true) {
  const rootMap = getMapPieceData(map);
  const battleZone = (map.scene.inZone && map.scene.inZone.rect) || {
    x: 0,
    y: 0,
    w: map.width,
    h: map.height
  };
  const hasKey = map.scene.game.registry.get('hasKey');
  const playerPieces = map.scene.pieces
    .getChildren()
    .filter(piece => piece.color === 'blue');
  const isCastle = map.scene.sys.config === 'CastleScene';
  const activeRooms = map.scene.currentActiveRooms
    ? { ...map.scene.currentActiveRooms, activePieces: null }
    : null;

  // console.log('data being sent to worker:', map.scene.inZone, {
  //   hasKey,
  //   isCastle,
  //   activeRooms,
  //   battleZone
  // });

  const { possibleMoves, nextMaps } = getNextMoveScores(
    { hasKey, isCastle, activeRooms, battleZone, playerPieces },
    rootMap,
    color
  );

  const possibleItemMoves = playerPieces
    .filter(p => p.itemID === 5 && p.itemCharges > 0)
    .flatMap(piece => getPossibleBowTargets(piece.tile, map.scene));

  return {
    possibleMoves,
    possibleItemMoves,
    nextMaps,
    hasKey,
    isCastle,
    activeRooms,
    battleZone,
    rootMap
  };
}
